import { DefaultFetchService } from "../fetchService";
import type { PostConfigObject } from "../fetchService";

const BASE_PATH = "sse/segment-rules-agent";

type SegmentRulesRunPayload = {
    domain: string;
    segmentDescription: string;
    country?: string;
};

type SegmentRulesThreadResponse = {
    threadId: string;
};

const createSegmentRulesAgentService = () => {
    const fetchService = DefaultFetchService.getInstance();

    const createThread = (): Promise<SegmentRulesThreadResponse> =>
        fetchService.post(`${BASE_PATH}/thread`);

    const runAgent = (
        threadId: string,
        payload: SegmentRulesRunPayload,
        config?: Pick<PostConfigObject, "cancellation">,
    ) =>
        fetchService.post(`${BASE_PATH}/run?threadId=${encodeURIComponent(threadId)}`, payload, {
            isRawResponse: true,
            withFullResponse: true,
            cancellation: config?.cancellation,
        });

    return { createThread, runAgent };
};

const segmentRulesAgentService = createSegmentRulesAgentService();

export default segmentRulesAgentService;

export type { SegmentRulesRunPayload, SegmentRulesThreadResponse };
